import { render } from "./ReviewsHotspot.vue?vue&type=template&id=0deaa8e0&ts=true"
import script from "./ReviewsHotspot.vue?vue&type=script&lang=ts"
export * from "./ReviewsHotspot.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__